import type { CoreOptions } from "@adyen/adyen-web/dist/types/core/types";
import getApp from "helpers/get_app";
import getEnv from "helpers/get_env";

export const ENV = getEnv();
export const APP = getApp();

export const ADYEN_CONSTANTS: {
  env: CoreOptions["environment"];
  clientKey: string;
  dataCollectionUrl: string;
} = (() => {
  if (ENV === "production") {
    return {
      env: "live-us",
      clientKey: "live_W3M4VO2SG5DN5GPMEA5DSNO4BYJJ5TBH",
      dataCollectionUrl:
        "https://checkoutshopper-live.adyen.com/checkoutshopper/assets/js/datacollection/datacollection.js",
    };
  }
  return {
    env: "test",
    clientKey: "test_XHFIACS4DZDHZK2KSSQ527MUNAGMG2NY",
    dataCollectionUrl:
      "https://checkoutshopper-test.adyen.com/checkoutshopper/assets/js/datacollection/datacollection.js",
  };
})();
